module.exports = __webpack_public_path__ + "static/media/top-left-orange.2d0f80e3.png";